import { render } from "./Mover.vue?vue&type=template&id=97b405a0&scoped=true"
import script from "./Mover.vue?vue&type=script&lang=js"
export * from "./Mover.vue?vue&type=script&lang=js"

import "./Mover.vue?vue&type=style&index=0&id=97b405a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b405a0"]])

export default __exports__